import * as API from '../'
export default {
    getEmpExamReport: params => {
      return API.GET('/api/examReport/getEmpExamReport', params)
    },
    getOrgExamReport: params => {
      return API.GET('/api/examReport/getOrgExamReport', params)
    },
    getTestPaper: params => {
        return API.GET('/api/examReport/getTestPaper', params)
    },
  }


// WEBPACK FOOTER //
// ./src/api/exam/api_exam_report.js